import { useMemo } from 'react';
import { REGIONS } from '../data/projectCard';
import { useGetRegionsQuery } from '../entities/session/api/sessionApi';

export function useRegions(current?: string): string[] {
    const { data } = useGetRegionsQuery();

    return useMemo(() => {
        const names = data?.length ? data.map((region) => region.name) : [...REGIONS];
        return current && !names.includes(current) ? [current, ...names] : names;
    }, [data, current]);
}